module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isExist) ? _c('div', {
    staticClass: "dn-top-messages"
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('p', {
      key: index,
      class: message.className || '',
      domProps: {
        "innerHTML": _vm._s(message.body)
      }
    })
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2fcee3e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/notices/TopMessages.vue
// module id = 379
// module chunks = 1